import styled from 'styled-components'
import { media } from '../../../styles/newTheme/theme'

export const NavbarWrapper = styled.header<{ $sidebarWidth: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;

  ${media.down('s')} {
    padding: 0 12px;
    height: 56px;
  }
  background: ${({ theme }) =>
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg, #0a0f1a 0%, #111827 100%)'
      : theme.palette.background.paper};
  border-bottom: 1px solid ${({ theme }) => (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : '#f1f5f9')};
  position: sticky;
  top: 0;
  z-index: 10;
  transition: background 0.2s, border-color 0.2s;
`

export const NavbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const NavbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const HamburgerButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${({ theme }) => theme.palette.text.primary};

  svg {
    width: 24px;
    height: 24px;
  }

  ${media.down('l')} {
    display: flex;
  }
`

export const CollapseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${({ theme }) => theme.palette.text.primary};

  svg {
    width: 24px;
    height: 24px;
  }

  ${media.down('l')} {
    display: none;
  }
`

export const IconButton = styled.button<{ title?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.text.secondary};
  transition: background 0.2s, color 0.2s;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: ${({ theme }) => (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#f5f7fa')};
    color: ${({ theme }) => theme.palette.text.primary};
  }
`
